<template>
  <div class="">
    <img src="assets/ASCP-New-Logo.svg" style="width:100%;"/>
  </div>
</template>

<script>
export default {
  name: "PavementHeader"
}
</script>

<style lang="css" scoped>
</style>
